import controller from './ktable.controller';
import template from './ktable.html';

/* globals Ktable */

/** @type {Ktable.KtableBindings} */
const bindings = {
	autoHeight:           '<?',
	component:            '<?',
	disabled:             '<?ngDisabled',
	ktableValidate:       '<?',
	onBeforeColumnCreate: '&?',
	onDataChanged:        '&?',
	onDataLoaded:         '&?',
	onReady:              '&?',
	options:              '<?',
	query:                '<?',
	queryNode:            '<?',
	reference:            '=?',
	tempKid:              '<?',
	values:               '<?',
	variables:            '<?',
	widgetActions:        '<?',
	widgetSettings:       '<?',
};

export default {
	template,
	bindings,
	controller,
	require: {
		builder:     '^^?formBuilder',
		kformCtrl:   '^^?kform',
		ngModelCtrl: 'ngModel',
		parentTab:   '^^?kformTabForm',
	},
};
